const _ = require("lodash");
const ruta3 = require("ruta3");
const moment = require("moment");
const PageShared = require("./PageShared");
const GradeChapter = require("./GradeChapter");
const StringUtil = require("./StringUtil");
const {EARLIEST_TRAINER_ACTIVITY_DATE} = require("./Constants");

const router = ruta3();

// Routes
// If you add something here, you should also update URLMake.js.

const notFoundPage = pathname => ({
	name: "404",
	pathname,
});

const schoolNotFoundPage = pathname => ({
	name: "home.main",
	errorMessageInfo: {
		messageType: "pageNotFound",
		notFound: pathname,
	},
});

const ensureValidDay = day => {
	const today = moment();
	if (!day) return today.format("YYYY-MM-DD");
	// check if date is not actual calendar date
	const givenDay = moment(day);
	if (
		!givenDay.isValid() ||
		today.diff(givenDay) <= 0 ||
		givenDay.isBefore(moment(EARLIEST_TRAINER_ACTIVITY_DATE, "YYYY-MM-DD"))
	)
		return today.format("YYYY-MM-DD");
	return givenDay.format("YYYY-MM-DD");
};

// DEMO HELPER

const addRoutePlusDemo = (url, pageObjReturnFunc) => {
	router.addRoute(url, pageObjReturnFunc);
	router.addRoute("/demo" + url, (...args) => {
		return _.extend(pageObjReturnFunc(...args), {demo: true});
	});
};

//OFFICE PAGES:

const forMain = params => {
	return {
		name: "office.main",
		openEmailModal: false,
	};
};
// Main
router.addRoute("/", forMain);
router.addRoute("/hswotrainingwheels", forMain); // OUTREACH

// Post-signin - shown while we determine which default page to show
// just-logged-in user
router.addRoute("/post-signin", params => {
	return {
		name: "home.postSignin",
	};
});

//Privacy
router.addRoute("/privacy", params => {
	return {
		name: "office.termsAndPrivacy",
		section: "privacy",
	};
});

//Terms
router.addRoute("/terms", params => {
	return {
		name: "office.termsAndPrivacy",
		section: "terms",
	};
});

//FAQ
router.addRoute("/faq/:opt?/:questionHash?", params => {
	let section = (params.opt || "").toLowerCase();
	if (!_.includes(["books", "online", "orders"], section)) {
		section = "books";
	}
	return {
		name: "office.faq",
		section: section,
		questionHash: (params.questionHash || "").toLowerCase() || null,
	};
});

//Contact
router.addRoute("/contact/:reason?", params => {
	return {
		name: "office.contact",
		reason: params.reason,
	};
});

//About
router.addRoute("/about", params => {
	return {
		name: "office.about",
	};
});

//Chalkboard
router.addRoute("/chalkboard", params => {
	return {
		name: "office.chalkboard",
	};
});

//CMS Info Pages
router.addRoute("/info/*", (params, splats) => {
	const cmsPath = _.get(splats, 0, "");
	return {
		name: "office.cmsInfoPages",
		cmsPath: cmsPath ? _.split(cmsPath, "/") : [],
	};
});

//BA Online
const forOnline = params => {
	return {
		name: "office.baonline",
	};
};
router.addRoute("/online", forOnline);
router.addRoute("/online/hswotrainingwheels", forOnline); // OUTREACH

router.addRoute("/online/enroll", params => {
	return {
		name: "office.enroll",
	};
});

router.addRoute("/online/enroll-monthly", params => {
	return {
		name: "office.enroll",
		preselectedOption: "monthly",
	};
});

router.addRoute("/online/enroll-yearly", params => {
	return {
		name: "office.enroll",
		preselectedOption: "yearly",
	};
});

router.addRoute("/online/enroll-bundle", params => {
	return {
		name: "office.enroll",
		preselectedOption: "bundle",
	};
});

router.addRoute("/gift", params => {
	return {
		name: "office.gifting",
	};
});

//BA Schools
// TODO determine a better URL structure
router.addRoute("/online/schools", params => {
	return {
		name: "office.schools",
	};
});

router.addRoute("/educators", params => {
	return {
		name: "office.educators",
	};
});

router.addRoute("/educators/outcomes", params => {
	return {
		name: "office.outcomes",
	};
});

router.addRoute("/puzzles/daily", params => {
	return {
		name: "puzzles.daily",
	};
});

router.addRoute("/puzzles/daily/*", params => {
	return {
		name: "puzzles.daily",
	};
});

router.addRoute("/all-ten", params => {
	return {
		name: "allten.play",
	};
});

router.addRoute("/allten", params => {
	return {
		name: "allten.play",
	};
});

router.addRoute("/live-classes", params => {
	return {
		name: "office.liveClasses",
	};
});

//BA Playground
router.addRoute("/playground/:activityName?", params => {
	return {
		name: "office.playground",
		activityName: _.trim(_.toLower(params.activityName), "."),
	};
});

//Resources (printables, assessments, errata)
const forResources = params => {
	let section = params.section || "printables";
	if (section === "assessments") section = "placementtests";

	return {
		name: "office.resources",
		section,
		planningCategoryHash: _.toLower(params.planningCategoryHash),
	};
};
router.addRoute(
	"/resources/:section(printables|assessments|placementtests|planning|errata|backgrounds)?/:planningCategoryHash?",
	forResources
);
router.addRoute(
	"/resources/:section(printables|assessments|placementstests|planning|errata|backgrounds)/hswotrainingwheels",
	forResources
); // OUTREACH

//Checking out steps
router.addRoute("/checkout/:step?", params => {
	return {
		name: "office.checkout",
		step: params.step || "cart",
	};
});

// Parent
router.addRoute("/parent", params => {
	return {
		name: "parent.main",
	};
});

router.addRoute("/parent/support", params => {
	return {
		name: "parent.support",
		section: "getstarted",
	};
});

router.addRoute("/parent/:s(student|students)", params => {
	const pageData = {
		name: "parent.main",
	};

	return pageData;
});

router.addRoute("/parent/students/:studentID(s[0-9]+)", params => {
	const pageData = {
		name: "parent.main",
	};
	const studentID =
		params.studentID && parseInt(params.studentID.substring(1), 10);
	if (studentID) {
		pageData.scrollStudentID = studentID;
	}

	return pageData;
});

router.addRoute(
	"/parent/students/:studentID([0-9]+)/giftBucksConfirmation",
	params => {
		const pageData = {
			name: "parent.giftBucksConfirmation",
			studentID: params.studentID,
		};
		return pageData;
	}
);

router.addRoute(
	"/parent/support/:section(getstarted|play|reports|account|lessonplanning|planning)/:topic?",
	params => {
		return {
			name: "parent.support",
			// redirect from old URL
			section:
				params.section === "lessonPlanning" ? "planning" : params.section,
			topic: params.topic,
		};
	}
);

router.addRoute("/parent/support/:section", params => {
	return {
		name: "parent.support",
		section: "getstarted",
	};
});

router.addRoute(
	"/parent/students/:studentID([0-9]+)/progress/:grade?/:chapterOrType([0-9]+)?/:block?",
	params => {
		const {studentID, grade, chapterOrType, block} = params;
		const chapterOrTypeID = _.isInteger(parseInt(chapterOrType))
			? parseInt(chapterOrType)
			: "";
		let useBlock = _.isInteger(parseInt(block)) ? parseInt(block) : block || "";
		let chapter, typeID;
		if (grade === "lab") {
			typeID = chapterOrTypeID;
		} else {
			chapter = chapterOrTypeID;
			if (_.isInteger(useBlock) && chapter) {
				const blockID = useBlock;
				const chapterIndex = chapter - 1;
				const chapterID =
					grade && GradeChapter.toChapterID(grade, chapterIndex);
				const blockIndex = GradeChapter.toBlockIndex(chapterID, blockID);
				useBlock = blockIndex + 1;
			}
		}
		return {
			name: "parent.student",
			pageData: {
				studentID: _.isInteger(parseInt(studentID)) ? parseInt(studentID) : "",
				type: "progress",
				grade: _.isInteger(parseInt(grade)) ? parseInt(grade) : grade || "",
				chapter,
				typeID,
				block: useBlock,
			},
		};
	}
);

router.addRoute(
	"/print/parent/students/:studentID([0-9]+)/progress/:grade?/:chapterOrType([0-9]+)?/:block?",
	params => {
		const {studentID, grade, chapterOrType, block} = params;
		const chapterOrTypeID = _.isInteger(parseInt(chapterOrType))
			? parseInt(chapterOrType)
			: "";
		let chapter, typeID;
		let useBlock = _.isInteger(parseInt(block)) ? parseInt(block) : block || "";
		if (grade === "lab") {
			typeID = chapterOrTypeID;
		} else {
			chapter = chapterOrTypeID;
			if (_.isInteger(useBlock) && chapter) {
				const blockID = useBlock;
				const chapterIndex = chapter - 1;
				const chapterID =
					grade && GradeChapter.toChapterID(grade, chapterIndex);
				const blockIndex = GradeChapter.toBlockIndex(chapterID, blockID);
				useBlock = blockIndex + 1;
			}
		}

		return {
			name: "parent.student",
			forPrint: true,
			pageData: {
				studentID: _.isInteger(parseInt(studentID)) ? parseInt(studentID) : "",
				type: "progress",
				grade: _.isInteger(parseInt(grade)) ? parseInt(grade) : grade || "",
				chapter,
				typeID,
				block: useBlock,
			},
		};
	}
);

router.addRoute(
	"/parent/students/:studentID([0-9]+)?/activity/:date?",
	params => {
		const {studentID, date} = params;
		return {
			name: "parent.student",
			pageData: {
				studentID: _.isInteger(parseInt(studentID)) ? parseInt(studentID) : "",
				type: "activity",
				date: ensureValidDay(date),
			},
		};
	}
);

router.addRoute("/parent/students/setup/:studentID([0-9]+)", params => {
	return {
		name: "parent.studentPrimaryRegistration",
		studentID: parseInt(params.studentID),
	};
});

router.addRoute("/parent/students/setup", params => {
	return {
		name: "parent.studentPrimaryRegistration",
		params,
	};
});

router.addRoute(
	"/print/student/problem/:resultID([0-9]+)/:problemIndex([0-9]+)",
	params => {
		return {
			name: "school.studentProblem",
			resultID: parseInt(params.resultID),
			problemIndex: parseInt(params.problemIndex),
			forPrint: true,
		};
	}
);

router.addRoute(
	"/print/block/problem/:userID([0-9]+)/:blockID([0-9]+)/:problemIndex",
	params => {
		const {problemIndex, blockID, userID} = params;
		const isTrophy = problemIndex === "trophy";
		return {
			name: "school.studentProblem",
			blockID: parseInt(blockID),
			userID: parseInt(userID),
			isTrophy,
			problemIndex: isTrophy ? 0 : parseInt(params.problemIndex),
			forPrint: true,
		};
	}
);

router.addRoute(
	"/print/lab/block/problem/:userID([0-9]+)/:blockID([0-9]+)/:problemIndex",
	params => {
		const {problemIndex, blockID, userID} = params;
		return {
			name: "school.studentProblem",
			space: "lab",
			blockID: parseInt(blockID),
			userID: parseInt(userID),
			problemIndex: parseInt(problemIndex),
			forPrint: true,
		};
	}
);

// Parent account pages

router.addRoute("/account/:opt?", params => {
	let section = (params.opt || "").toLowerCase();
	if (!_.includes(["subscriptions", "information"], section)) {
		section = "subscriptions";
	}
	return {
		name: "parent.account",
		section: section,
		extraInfo: null,
	};
});

router.addRoute(
	"/account/:section(subscriptions|information)/:opt?",
	params => {
		return {
			name: "parent.account",
			section: params.section,
			extraInfo: params.opt,
		};
	}
);

router.addRoute("/account/add/:step", params => {
	return {
		name: "parent.subscribe",
		changeType: "add",
		studentID: null,
		step: params.step,
	};
});

router.addRoute(
	"/account/:changeType(reactivate|renew|switch|upgrade)/:id/:step?",
	params => {
		const studentID = parseInt(params.id, 10);
		let step = (params.step || "").toLowerCase();
		if (
			!_.includes(
				["subscribe", "shipping", "billing", "review", "confirm"],
				step
			)
		) {
			step = "subscribe";
		}
		return {
			name: "parent.subscribe",
			changeType: params.changeType,
			studentID: _.isInteger(studentID) ? studentID : "",
			step,
		};
	}
);

//Bookstore
const forBookstore = params => {
	return {
		name: "office.bookstore",
	};
};
router.addRoute("/books", forBookstore);
router.addRoute("/science", forBookstore);
router.addRoute("/books/hswotrainingwheels", forBookstore); // OUTREACH

router.addRoute("/playingcards", params => {
	return {
		name: "playingcards.main",
	};
});

router.addRoute("/playingcards/answers", params => {
	return {
		name: "playingcards.answers",
	};
});

// Routes /cards to /playingcards?utm_source=cards
router.addRoute("/cards", params => {
	return {
		name: "playingcards.redirect",
		utm_source: "cards",
	};
});

router.addRoute("/playingcards/answers", params => {
	return {
		name: "playingcards.answers",
	};
});

//Bookstore collections
router.addRoute("/books/collections", params => {
	return {
		name: "office.bookstore",
		section: "collections",
	};
});

//Apparel
const availableApparelRegex = PageShared.getApparelRegex();
router.addRoute("/apparel/:apparelHash?", params => {
	const apparelHash =
		params.apparelHash && availableApparelRegex.test(params.apparelHash)
			? params.apparelHash.toLowerCase()
			: "shirt-beast";
	return {
		name: "office.apparel",
		apparelHash,
	};
});

router.addRoute("/cards", () => {
	return {
		name: "office.cards",
	};
});

router.addRoute("/playingcards", () => {
	return {
		name: "office.playingcards",
	};
});

//Specific book page
const availableBookRegex = PageShared.getAvailableBookRegex();
router.addRoute(
	"/books/:bookHash/:mask(fullset|fullset-plus-puzzles|guide-practice|guide|practice)",
	params => {
		if (params.bookHash && availableBookRegex.test(params.bookHash)) {
			const isPuzzleBook = PageShared.isPuzzleBook(params.bookHash);
			const bookHash = isPuzzleBook
				? params.bookHash.toLowerCase()
				: params.bookHash.toUpperCase();
			if (!isPuzzleBook) {
				if (
					(!availableBookRegex.test(`puzzles${parseInt(bookHash)}`) &&
						_.includes(params.mask, "puzzles")) ||
					(!_.includes(PageShared.availableGradeSets, parseInt(bookHash)) &&
						_.includes(params.mask, "fullset"))
				) {
					return {
						name: "office.book",
						bookHash,
					};
				}
				return {
					name: "office.book",
					bookHash,
					hashMask: params.mask,
				};
			}
			return {
				name: "office.book",
				bookHash: bookHash,
			};
		} else {
			return {
				name: "office.bookstore",
			};
		}
	}
);
router.addRoute("/books/science/:bookHash", params => {
	const isLevel = params.bookHash.toLowerCase().slice(0, 5) === "level";
	if (isLevel) {
		return {
			name: "office.bookLevelScience",
			bookHash: params.bookHash.toLowerCase(),
			level: parseInt(params.bookHash.split("-")[1], 10),
		};
	}
	return {
		name: "office.bookScience",
		bookHash: params.bookHash.toUpperCase(),
	};
});

router.addRoute("/books/:bookHash?", params => {
	if (params.bookHash && availableBookRegex.test(params.bookHash)) {
		const bookHash = PageShared.isPuzzleBook(params.bookHash)
			? params.bookHash.toLowerCase()
			: params.bookHash.toUpperCase();
		return {
			name: "office.book",
			bookHash,
		};
	} else if (params.bookHash && /^all-titles$/.test(params.bookHash)) {
		return {
			name: "office.allbooks",
		};
	} else {
		const availableBookLevels = PageShared.getAvailableBookLevels();
		const hashSplit = params.bookHash.split("-");
		if (
			hashSplit[0] === "level" &&
			_.includes(availableBookLevels, parseInt(hashSplit[1]))
		) {
			return {
				name: "office.bookLevel",
				level: parseInt(hashSplit[1]),
			};
		}
		return {
			name: "office.bookstore",
		};
	}
});

// Mailing list modal on home
router.addRoute("/mailingList", params => {
	return {
		name: "office.main",
		openEmailModal: true,
	};
});

// Mailing list pages
router.addRoute("/mailingList/confirm", params => {
	// The :codeOnError? optional parameter is necessary to trigger this route
	// when there is an error, even though we don't use that information here
	return {
		name: "office.mailinglist",
		type: "confirm",
	};
});

router.addRoute(
	"/mailingList/unsubscribe/:subType/:codeOrError/:codeOnError?",
	params => {
		// The :codeOnError? optional parameter is necessary to trigger this route
		// when there is an error, even though we don't use that information here
		return {
			name: "office.mailinglist",
			type: "unsubscribe",
			subType: params.subType,
			error:
				(params.codeOrError || "").substr(0, 5) === "error"
					? params.codeOrError
					: null,
		};
	}
);

// Email confirmation
// confirm - endpoint for confirmation
// confirmation - for initial email account setup
// confirmed - already confirmed email with link
// update - for changing account email
// outdated - using old confirmation code when new email confirmation code is set
// invalid - setting a new email for email already in use by another user
// error - for invalid confirmation codes
router.addRoute(
	"/confirmEmail/:type(confirm|error|confirmation|confirmed|update|invalid|outdated)/:opt?",
	params => {
		return {
			name: "office.confirmEmail",
			type: params.type,
			email: params.opt,
		};
	}
);

// Auto renew enabling
// enabled - displays page telling user they successfully turned autorenew on
// error - displays page telling user that we couldn't turn on their autorenew
router.addRoute("/autorenew/:type(enabled|error)/:code", params => {
	return {
		name: "office.autoRenew",
		type: params.type,
	};
});

// Purchase Order Account Setup
router.addRoute(
	"/:type(purchaseOrderSetup|parentSetup)/:isMultiple/:email/:code",
	params => {
		return {
			name: "office.accountSetup",
			isMultiple: parseInt(params.isMultiple) || 0,
			code: params.code,
			email: decodeURIComponent(params.email),
			type: "parent",
		};
	}
);

// For existing platform users but not yet BA
router.addRoute("/baParentSetup/:isMultiple/:email/:code", params => {
	return {
		name: "office.accountSetup",
		isMultiple: parseInt(params.isMultiple) || 0,
		code: params.code,
		email: decodeURIComponent(params.email),
		type: "parent",
		requireLoggedIn: true,
	};
});

// Redeem Subscription Code
router.addRoute("/redeemSubscription/:step?", params => {
	return {
		name: "office.redeemSubscription",
		step: "code",
	};
});

// Home
router.addRoute("/demo", params => {
	return {
		name: "home.main",
		demo: true,
	};
});

addRoutePlusDemo("/school", params => {
	return {
		name: "home.main",
	};
});

addRoutePlusDemo("/school/home", params => {
	return {
		name: "home.main",
	};
});

router.addRoute("/school/leaderboards", params => {
	return {
		name: "home.main",
		shouldOpenLeaderboards: true,
	};
});

// Onboarding
router.addRoute("/onboarding", params => {
	return {
		name: "home.onboarding",
	};
});

// Library
router.addRoute("/school/library/:gradeNumber?", params => {
	const grade = parseInt(params.gradeNumber, 10);
	return {
		name: "library.grade",
		gradeNumber: _.isInteger(grade) ? grade : "",
	};
});

router.addRoute("/demo/school/library/:gradeNumber?", params => {
	return {
		name: "library.grade",
		gradeNumber: 0,
		demo: true,
	};
});

router.addRoute(
	"/school/library/:gradeNumber/:chapter/:sectionOrPage?",
	params => {
		// Section info doesn't check for NaN because it doesn't show up in URL
		const grade = parseInt(params.gradeNumber, 10);
		const chapter = parseInt(params.chapter, 10);
		const pageObj = {
			name: "library.chapter",
			gradeNumber: _.isInteger(grade) ? grade : "",
			chapterIndex: _.isInteger(chapter) ? chapter - 1 : "",
		};

		// If last section is in the form p###, then go to page ### in that chapter.
		const sop = params.sectionOrPage;
		if (sop && sop.substring(0, 1) === "p") {
			pageObj.pageNumber = parseInt(sop.substring(1));
		} else if (sop) {
			pageObj.sectionIndex = parseInt(sop) - 1;
		}
		return pageObj;
	}
);

router.addRoute(
	"/demo/school/library/:gradeNumber/:chapter/:sectionOrPage?",
	params => {
		const grade = parseInt(params.gradeNumber, 10);
		const chapter = parseInt(params.chapter, 10);
		const chapterID =
			_.isInteger(grade) &&
			_.isInteger(chapter) &&
			GradeChapter.toChapterID(grade, chapter - 1);
		let pageObj;
		if (chapterID) {
			pageObj = {
				name: "library.chapter",
				gradeNumber: grade,
				chapterIndex: chapter - 1,
			};
		} else {
			pageObj = {
				name: "library.grade",
				gradeNumber: 0,
			};
		}

		pageObj.demo = true;
		return pageObj;
	}
);

//Videos
addRoutePlusDemo(
	"/school/theater/:gradeNumber/:chapter/:block/:video?",
	params => {
		return getTheaterContext(params);
	}
);

addRoutePlusDemo("/school/theater/:gradeNumber/:chapter/:block?", params => {
	return getTheaterContext(params);
});

addRoutePlusDemo("/school/theater/:gradeNumber/:chapter?", params => {
	return getTheaterContext(params);
});

addRoutePlusDemo("/school/theater/:gradeNumber?", params => {
	return getTheaterContext(params);
});

// Lab

router.addRoute("/school/lab", params => {
	return {
		name: "lab.lobby",
	};
});

router.addRoute("/school/lab/:typeID", params => {
	const {typeID} = params;
	return {
		name: "lab.type",
		typeID: _.isInteger(parseInt(typeID)) ? parseInt(typeID) : null,
	};
});

router.addRoute("/school/lab/:typeID/:blockID/:problemIndex?", params => {
	const {typeID, blockID} = params;
	let problemIndex = params.problemIndex;
	if (problemIndex !== undefined) {
		if (_.isString(problemIndex) && problemIndex.toLowerCase() === "summary") {
			problemIndex = problemIndex.toLowerCase();
		} else {
			problemIndex = Math.abs(parseInt(problemIndex, 10)) - 1;
			problemIndex = _.isInteger(problemIndex) ? problemIndex : undefined;
		}
	}
	return {
		name: "lab.problem",
		typeID: _.isInteger(parseInt(typeID)) ? parseInt(typeID) : null,
		blockID: _.isInteger(parseInt(blockID)) ? parseInt(blockID) : null,
		problemIndex,
		showInstructions: false,
	};
});

// Trainer

router.addRoute("/school/classroom/:gradeNumber?", params => {
	//Using "" instead of parseInt so NaN doesn't show up in URL bar
	const grade = parseInt(params.gradeNumber, 10);
	return {
		name: "trainer.chapter",
		gradeNumber: _.isInteger(grade) ? grade : "",
		chapterIndex: "",
	};
});

router.addRoute("/demo/school/classroom", params => {
	return {
		name: "trainer.chapter",
		gradeNumber: 0,
		chapterIndex: 0,
		demo: true,
	};
});

router.addRoute("/online/save-with-friends", params => {
	return {
		name: "office.savewithfriends",
	};
});

router.addRoute("/school/classroom/dev/engineTester", () => ({
	name: "trainer.devEngineTester",
}));

router.addRoute("/school/classroom/dev/:problemName", params => {
	return {
		name: "trainer.devProblem",
		devProblemName: params.problemName,
	};
});

router.addRoute("/school/classroom/book-test/:bookHash/:problem?", params => {
	params.bookTestHash = params.bookHash
		? `bookTest${_.toUpper(params.bookHash)}`
		: null;
	params.gradeNumber = parseInt(params.bookHash.substring(0, 1));
	delete params.bookHash;
	return getBookTestContext(params);
});

addRoutePlusDemo("/school/classroom/:gradeNumber/:chapter?", params => {
	const chapter = Math.abs(parseInt(params.chapter, 10));
	const grade = parseInt(params.gradeNumber, 10);
	const chapterIndex = _.isInteger(chapter) ? chapter - 1 : "";
	const gradeNumber = _.isInteger(grade) ? grade : "";
	return {
		name: "trainer.chapter",
		gradeNumber,
		chapterIndex,
	};
});

addRoutePlusDemo(
	"/school/classroom/:gradeNumber/:chapter/book/:book?",
	params => {
		const chapter = Math.abs(parseInt(params.chapter, 10));
		const grade = parseInt(params.gradeNumber, 10);
		const book = parseInt(params.book, 10);
		const chapterIndex = _.isInteger(chapter) ? chapter - 1 : "";
		const gradeNumber = _.isInteger(grade) ? grade : "";
		const showBookSectionID = _.isInteger(book) ? book : "";
		return {
			name: "trainer.chapter",
			gradeNumber,
			chapterIndex,
			showBook: true,
			showBookSectionID,
		};
	}
);

addRoutePlusDemo(
	"/school/classroom/:gradeNumber/:chapter/:block/results/:problem?",
	params => {
		return getProblemContext(params, true);
	}
);

addRoutePlusDemo(
	"/school/classroom/:gradeNumber/:chapter/:block/:problem?",
	params => {
		return getProblemContext(params);
	}
);

// This route does not need demo. For going to a specific set.
router.addRoute(
	"/school/classroom/:gradeNumber/:chapter/:block/:problem/set/:setNumber",
	params => {
		return getProblemContext(params);
	}
);

router.addRoute("/school/classroom/*", (params, splats) => {
	return {
		name: "trainer.chapter",
		gradeNumber: splats[0],
		chapterIndex: splats[1],
	};
});

// Profile

addRoutePlusDemo("/school/:p(profile|office)", params => {
	return {
		name: "profile.main",
		currentTab: "profile",
	};
});

addRoutePlusDemo("/school/:p(profile|office)/progress", params => {
	return {
		name: "profile.main",
		currentTab: "progress",
	};
});

addRoutePlusDemo("/school/:p(profile|office)/homework", params => {
	return {
		name: "profile.main",
		currentTab: "homework",
	};
});

addRoutePlusDemo(
	"/school/:p(profile|office)/activity/:toggleType?/:activeDay?",
	params => {
		const day = ensureValidDay(params.activeDay);
		return {
			name: "profile.main",
			currentTab: "activity",
			activity: {
				day,
				toggleType: params.toggleType || "minutes",
			},
		};
	}
);

addRoutePlusDemo("/school/:p(profile|office)/*", params => {
	return {
		name: "profile.main",
	};
});

router.addRoute("/school/permission_denied", params => {
	return {
		name: "home.main",
		errorMessageInfo: {
			messageType: "noTrainerPermission",
		},
	};
});

// Beast Builder

router.addRoute("/school/beastbuilder", params => {
	return {
		name: "beastbuilder.main",
	};
});

// BA Schools

// The routes below use this helper by forwarding params here and passing an
// object for the second parameter describing the kind of URL.
const makeSchoolMainReports = function(params, extra) {
	const {first} = params;
	const tab = extra.tab || params.tab || extra.defaultTab;
	const isBookTest =
		params.chapterOrType && params.chapterOrType.startsWith("book-test");

	const intIfPossible = (val, defaultValue) => {
		const intVal = parseInt(val);
		if (_.isInteger(intVal)) return intVal;
		return defaultValue || "";
	};
	const intOrString = val => intIfPossible(val, val);

	const pageData = {};
	if (first === "system") {
		// Leave pageData empty.
	} else if (first === "schools") {
		pageData.schoolID = intIfPossible(params.schoolID);
	} else if (first === "students" && extra.activity) {
		pageData.type = "activity";
		pageData.studentID = intIfPossible(params.studentID);
		pageData.date = ensureValidDay(params.date);
	} else if (first === "classes" || first === "students") {
		pageData.type = "progress";
		if (first === "classes") {
			pageData.classID = intIfPossible(params.classID);
		} else {
			pageData.studentID = intIfPossible(params.studentID);
		}
		pageData.grade = intOrString(params.grade);
		pageData.chapter = null;
		pageData.block = null;
		pageData.bookTest = null;
		pageData.typeID = null;
		pageData.labBlockID = null;
		if (params.grade === "lab") {
			pageData.typeID = intIfPossible(params.chapterOrType);
			if (first !== "students" && pageData.typeID) {
				pageData.labBlockID = intOrString(params.blockOrID);
			}
		} else if (isBookTest) {
			// Remove book-test-
			pageData.bookTest = params.chapterOrType.slice(10);
		} else {
			pageData.chapter = intIfPossible(params.chapterOrType);
			if (pageData.chapter) {
				pageData.block = intOrString(params.blockOrID);
				if (_.isInteger(pageData.block)) {
					const blockID = pageData.block;
					const chapterIndex = pageData.chapter - 1;
					const chapterID =
						pageData.grade &&
						GradeChapter.toChapterID(pageData.grade, chapterIndex);
					const blockIndex = GradeChapter.toBlockIndex(chapterID, blockID);
					pageData.block = blockIndex + 1;
				}
			}
		}
	}
	const pageState = {
		name: "school.main",
		space: "reports",
		tab,
		pageData,
	};
	if (extra.forPrint) {
		pageState.forPrint = true;
	}
	return pageState;
};

/* Reports */

router.addRoute(
	"/dashboard/reports/:first(schools)/:schoolID([0-9]+)/:tab(classes|students)?",
	params => makeSchoolMainReports(params, {defaultTab: "classes"})
);

router.addRoute(
	"/dashboard/reports/:first(system)/:tab(classes|students|schools)?",
	params => makeSchoolMainReports(params, {defaultTab: "schools"})
);

router.addRoute(
	"/dashboard/reports/:first(classes)/:classID([0-9]+)/progress/:grade?/:chapterOrType?/:blockOrID?",
	params => makeSchoolMainReports(params, {tab: "classes"})
);

router.addRoute(
	"/dashboard/reports/:first(students)/:studentID([0-9]+)/progress/:grade?/:chapterOrType?/:blockOrID?",
	params => makeSchoolMainReports(params, {tab: "students"})
);

router.addRoute(
	"/print/dashboard/reports/:first(classes)/:classID([0-9]+)/progress/:grade?/:chapterOrType?/:blockOrID?",
	params => makeSchoolMainReports(params, {tab: "classes", forPrint: true})
);

router.addRoute(
	"/print/dashboard/reports/:first(students)/:studentID([0-9]+)/progress/:grade?/:chapterOrType?/:blockOrID?",
	params => makeSchoolMainReports(params, {tab: "students", forPrint: true})
);

router.addRoute(
	"/dashboard/reports/:first(students)/:studentID([0-9]+)/activity/:date?",
	params => makeSchoolMainReports(params, {tab: "students", activity: true})
);

router.addRoute("/dashboard/reports/academy-tests", () => ({
	name: "school.testList",
}));

router.addRoute(
	"/print/class/:classID([0-9]+)/:grade?/:chapterOrType([0-9]+)?/:block?",
	params => {
		const {classID, grade, chapterOrType, block} = params;
		const chapterOrTypeID = _.isInteger(parseInt(chapterOrType))
			? parseInt(chapterOrType)
			: "";
		let useBlock = _.isInteger(parseInt(block)) ? parseInt(block) : block || "";
		let chapter, typeID;
		if (grade === "lab") {
			typeID = chapterOrTypeID;
		} else {
			chapter = chapterOrTypeID;
			if (_.isInteger(useBlock) && chapter) {
				const blockID = useBlock;
				const chapterIndex = chapter - 1;
				const chapterID =
					grade && GradeChapter.toChapterID(grade, chapterIndex);
				const blockIndex = GradeChapter.toBlockIndex(chapterID, blockID);
				useBlock = blockIndex + 1;
			}
		}
		return {
			name: "school.classReports",
			pageData: {
				classID: _.isInteger(parseInt(classID)) ? parseInt(classID) : "",
				type: "progress",
				grade: _.isInteger(parseInt(grade)) ? parseInt(grade) : grade || "",
				chapter,
				typeID,
				block: useBlock,
			},
			forPrint: true,
		};
	}
);

/* School Accounts */

router.addRoute(
	"/dashboard/accounts/system/:tab(classes|students|staff|schools|subscription)?/:rosteringStep(staff-csv|student-csv|upload|review)?",
	params => {
		const {tab, rosteringStep} = params;
		return {
			name: "school.main",
			space: "accounts",
			tab: tab || "subscription",
			pageData: {
				rosteringStep,
			},
		};
	}
);

router.addRoute(
	"/dashboard/accounts/schools/:schoolID([0-9]+)/:tab(classes|students|staff|subscription)?",
	params => {
		const {schoolID, tab} = params;
		return {
			name: "school.main",
			space: "accounts",
			tab: tab || "classes",
			pageData: {
				schoolID: _.isInteger(parseInt(schoolID)) ? parseInt(schoolID) : "",
			},
		};
	}
);

router.addRoute("/dashboard/accounts/classes/:classID([0-9]+)", params => {
	const {classID} = params;
	return {
		name: "school.main",
		space: "accounts",
		pageData: {
			classID: _.isInteger(parseInt(classID)) ? parseInt(classID) : "",
		},
	};
});

router.addRoute("/dashboard/accounts/users/:userID([0-9]+)?", params => {
	const {userID} = params;
	return {
		name: "school.main",
		space: "accounts",
		pageData: {
			userID: _.isInteger(parseInt(userID)) ? parseInt(userID) : "",
		},
	};
});

router.addRoute("/accountSetup/:email/:code", params => {
	return {
		name: "office.accountSetup",
		code: params.code,
		email: decodeURIComponent(params.email),
		type: "staff",
	};
});

router.addRoute("/baAccountSetup/:email/:code", params => {
	return {
		name: "office.accountSetup",
		code: params.code,
		email: decodeURIComponent(params.email),
		type: "staff",
		requireLoggedIn: true,
	};
});

/* Name cards for a class */

router.addRoute(
	"/dashboard/classcards/:classID([0-9]+)/:instructions?",
	params => {
		const {classID, instructions} = params;
		return {
			name: "school.classCards",
			classID: parseInt(classID),
			instructions: instructions
				? StringUtil.convertFromCharCode(instructions)
				: "",
			forPrint: true,
		};
	}
);

/* School Support/Guide */

router.addRoute("/dashboard/support/:tab?/:topic?", params => {
	const actualTab = params.tab === "lessonPlanning" ? "planning" : params.tab;
	return {
		name: "school.main",
		space: "support",
		tab: actualTab || "play",
		pageData: {
			topic: params.topic,
		},
	};
});

/* School Staff Profile */

router.addRoute("/dashboard/profile", params => {
	return {
		name: "school.profile",
	};
});

/* Old Teacher pages reroute to school */

router.addRoute("/teacher/class", params => {
	return {
		name: "school.main",
		space: "reports",
		pageData: {},
	};
});

router.addRoute("/teacher/manage", params => {
	return {
		name: "school.main",
		space: "accounts",
		tab: "classes",
		pageData: {},
	};
});

router.addRoute("/teacher/student/:studentID?/:date?", params => {
	const {studentID, date} = params;
	return {
		name: "school.main",
		space: "reports",
		tab: "students",
		pageData: {
			studentID: _.isInteger(parseInt(studentID)) ? parseInt(studentID) : "",
			type: date ? "activity" : "progress",
			date: date ? ensureValidDay(date) : null,
		},
	};
});

router.addRoute("/teacher/content/:opt?", params => {
	return {
		name: "school.main",
		space: "reports",
		tab: "classes",
		pageData: {},
	};
});

/* Old parent guide, reroute to new parent support page */

router.addRoute("/parent/guide/:section?/:topic?", params => {
	return {
		name: "parent.support",
		section: params.section,
		topic: params.topic,
	};
});

const shouldDisableAnalytics = function(url) {
	// on trainer and login pages, to avoid tracking students
	// /login redirects to /school/signin
	return /^\/school/.test(url);
};

const parseURL = function(href, pageData) {
	let page;
	href = href.replace(/\?.*/, "");
	const match = router.match(href);
	if (!match) {
		if (/^\/school/.test(href)) {
			const adminRedirectPrefix = "/school/__";

			if (_.startsWith(href, adminRedirectPrefix)) {
				href = "/" + href.substring(adminRedirectPrefix.length);
			}

			page = schoolNotFoundPage(href);
		} else {
			page = notFoundPage(href);
		}
	} else {
		page = _.extend(match.action(match.params, match.splats), {
			extra: pageData || null,
		});
	}
	return page;
};

// Helpers

const getProblemContext = function(params, forHistory) {
	const chapter = Math.abs(parseInt(params.chapter, 10));
	const grade = parseInt(params.gradeNumber, 10);
	const chapterIndex = _.isInteger(chapter) ? chapter - 1 : "";
	const gradeNumber = _.isInteger(grade) ? grade : "";
	let blockIndex = null;
	let blockType = "character";
	if (_.includes(["review", "test", "challenge"], params.block.toLowerCase())) {
		blockType = params.block.toLowerCase();
	} else {
		const blockID = Math.abs(parseInt(params.block, 10));
		const chapterID =
			gradeNumber && GradeChapter.toChapterID(gradeNumber, chapterIndex);
		blockIndex = GradeChapter.toBlockIndex(chapterID, blockID);
		//If blockID didn't produce a valid block index, just return the chapter page:
		if (!_.isInteger(blockIndex)) {
			return {
				name: "trainer.chapter",
				gradeNumber,
				chapterIndex,
			};
		}
	}

	let problemIndex = params.problem;
	let setNumber = null;
	if (problemIndex !== undefined) {
		if (_.isString(problemIndex) && problemIndex.toLowerCase() === "summary") {
			problemIndex = problemIndex.toLowerCase();
		} else if (
			blockType !== "character" &&
			_.isString(problemIndex) &&
			problemIndex.toLowerCase() === "overview"
		) {
			problemIndex = problemIndex.toLowerCase();
		} else if (
			blockType === "character" &&
			_.isString(problemIndex) &&
			problemIndex.toLowerCase() === "trophy"
		) {
			problemIndex = problemIndex.toLowerCase();
		} else {
			problemIndex = Math.abs(parseInt(params.problem, 10)) - 1;
			problemIndex = _.isInteger(problemIndex) ? problemIndex : undefined;
			setNumber = parseInt(params.setNumber);
		}
	} else if (forHistory) {
		problemIndex = "history";
	}

	return {
		name: forHistory ? "trainer.history" : "trainer.problem",
		gradeNumber,
		chapterIndex,
		blockIndex,
		blockType,
		problemIndex,
		setNumber,
		showInstructions: false,
	};
};

const getBookTestContext = function(params) {
	let problemIndex = _.get(params, "problem");
	const {bookTestHash, gradeNumber} = params;
	const bookHashes = PageShared.getAvailableBooks({excludeTypes: "puzzles"});
	const validHashes = bookHashes.map(h => `bookTest${h}`);
	if (!_.includes(validHashes, bookTestHash)) {
		return {
			name: "home.main",
			errorMessageInfo: {messageType: "problemLoadingBookTest"},
		};
	}

	if (problemIndex !== undefined) {
		if (
			_.isString(problemIndex) &&
			(problemIndex.toLowerCase() === "summary" ||
				problemIndex.toLowerCase() === "overview")
		) {
			problemIndex = problemIndex.toLowerCase();
		} else {
			problemIndex = Math.abs(parseInt(params.problem, 10)) - 1;
			problemIndex = _.isInteger(problemIndex) ? problemIndex : undefined;
		}
	}

	return {
		name: "trainer.problem",
		blockType: "test",
		gradeNumber,
		bookTestHash,
		problemIndex,
		showInstructions: false,
	};
};

const isCollapsedLibraryAndTheater = function() {
	const flags =
		(global.SERVER_JS_GLOBAL && global.SERVER_JS_GLOBAL.BA_FEATURE_FLAGS) || {};
	return !!flags.ENABLE_COLLAPSED_LIBRARY_AND_THEATER;
};

const getTheaterContext = function(params) {
	const grade = parseInt(params.gradeNumber, 10);
	const gradeNumber = _.isInteger(grade) ? grade : "";
	const chapter = Math.abs(parseInt(params.chapter, 10));
	const chapterIndex = _.isInteger(chapter) ? chapter - 1 : "";
	const block = Math.abs(parseInt(params.block, 10));
	const blockID = _.isInteger(block) ? block : "";
	const video = Math.abs(parseInt(params.video, 10));
	const videoIndex = _.isInteger(video) ? video - 1 : "";

	// Collapsed Library+Theater: bare /theater landings (no video set) become
	// the merged library page on the Videos tab. theater.set stays unchanged.
	if (isCollapsedLibraryAndTheater() && !blockID) {
		const pageObj = {
			name: "library.grade",
			gradeNumber,
			tab: "videos",
		};
		if (_.isNumber(chapterIndex)) {
			pageObj.chapterIndex = chapterIndex;
		}
		return pageObj;
	}

	return {
		name: block ? "theater.set" : "theater.chapter",
		gradeNumber,
		chapterIndex,
		blockID,
		videoIndex,
	};
};

module.exports = {
	parseURL,
	shouldDisableAnalytics,
};
